// HowItWorks.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Classes from './Hero.module.css';
import { ArrowCircleIcon } from '../../../../../utils/Icons';
import StoreSelectionPopup from '../../../../GlobalComp/Footer/StoreSelectionPopup';

const IOS_APP_LINK =
  'https://apps.apple.com/us/app/fuelclubs/id6753362541';
const ANDROID_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.devzona.fuelclubs';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

export default function Hero() {
  const navigateTo = useNavigate();
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1280
  );
  const [showStorePopup, setShowStorePopup] = useState(false);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width < 768;

  const handleGetStarted = () => {
    // if (isMobile) {
    //   // Mobile → open store selection popup
    //   setShowStorePopup(true);
    // } else {
    //   // Desktop → go to signup
      
    // }
    navigateTo('/signup');
  };

  const handleStoreSelect = (platform) => {
    const url = platform === 'ios' ? IOS_APP_LINK : ANDROID_APP_LINK;
    window.open(url, '_blank');
  };

  const calendarImg = '/assets/images/calendar.webp';
  const trackingImg = '/assets/images/tracking.webp';
  const invoiceImg = '/assets/images/invoice.webp';

  return (
    <>
      <motion.div id="howItWorks" className={Classes.hero}>
        {/* Heading */}
        {/* <motion.div className={Classes.miniText} variants={fadeUp}>
          How it Works
        </motion.div> */}

        <motion.h1 className={Classes.subheading} variants={fadeUp}>
          How it Works
        </motion.h1>

        <motion.p className={Classes.text} variants={fadeUp}>
          Follow our simple step-by-step guide to make your FuelClubs experience easy from <br /> start to finish
        </motion.p>

        {/* ====== Steps (Desktop grid; Mobile reordered via CSS only) ====== */}
        <div className={Classes.stepsGrid}>
          {/* Vertical timeline for desktop */}
          <div className={Classes.timeline} aria-hidden="true">
            <span className={`${Classes.dot} ${Classes.dot1}`}>1</span>
            <span className={`${Classes.dot} ${Classes.dot2}`}>2</span>
            <span className={`${Classes.dot} ${Classes.dot3}`}>3</span>
          </div>

          {/* Row 1 — Desktop: Image (left), Content (right) */}
          <motion.div className={`${Classes.media} ${Classes.cardLg}`}>
            <motion.img
              src={calendarImg}
              alt="Calendar scheduling"
              className={Classes.cardImg}
            />
          </motion.div>

          <motion.div className={Classes.content}>
            <h1 className={Classes.title}>Schedule</h1>
            <p className={Classes.desc}>
              Pick the date and time that fits your schedule, then quickly set up your fuel delivery with just a few taps through our website or mobile app.
            </p>
            <button className={Classes.cta} onClick={handleGetStarted}>
              <h5>Get Started</h5>
              <ArrowCircleIcon height="22" fill={'var(--primary-color)'} />
            </button>
          </motion.div>

          {/* Row 2 — Desktop: Content (left), Image (right) */}
          <motion.div className={Classes.content}>
            <h1 className={Classes.title}>Track</h1>
            <p className={Classes.desc}>
              Stay updated from the moment your order is confirmed until your tank is full, with live status updates.
            </p>
            <button className={Classes.cta} onClick={handleGetStarted}>
              <h5>Get Started</h5>
              <ArrowCircleIcon height="22" fill={'var(--primary-color)'} />
            </button>
          </motion.div>

          <motion.div className={`${Classes.media} ${Classes.cardSm}`}>
            <motion.img
              src={trackingImg}
              alt="Track appointment"
              className={Classes.cardImg}
            />
          </motion.div>

          {/* Row 3 — Desktop: Image (left), Content (right) */}
          <motion.div className={`${Classes.media} ${Classes.cardLg}`}>
            <motion.img
              src={invoiceImg}
              alt="Invoice"
              className={Classes.cardImg}
            />
          </motion.div>

          <motion.div className={Classes.content}>
            <h1 className={Classes.title}>Delivered</h1>
            <p className={Classes.desc}>
              Whether at home, work, or anywhere in our service area, we bring fuel directly to you — no gas station trips needed.
            </p>
            <button className={Classes.cta} onClick={handleGetStarted}>
              <h5>Get Started</h5>
              <ArrowCircleIcon height="22" fill={'var(--primary-color)'} />
            </button>
          </motion.div>
        </div>
      </motion.div>

      {/* Reusable Store Selection Popup */}
      <StoreSelectionPopup
        open={showStorePopup}
        onClose={() => setShowStorePopup(false)}
        onSelect={handleStoreSelect}
      />
    </>
  );
}
